var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",class:{
    'open': _vm.isActive
  }},[_c('span',{staticClass:"accordion-title",on:{"click":_vm.toggleAccordion}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"accordion-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }